import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AccountType } from "@front/m19-api-client";
import { AccountSelectionService } from "@front/m19-services";
import { SellerInventoryComponent } from "./seller-inventory/seller-inventory.component";
import { VendorInventoryComponent } from "./vendor-inventory/vendor-inventory.component";

@Component({
  selector: "app-inventory",
  template: `@if (accountMarketplace()?.accountType !== AccountType.SELLER) {
      <app-vendor-inventory></app-vendor-inventory>
    } @else {
      <app-seller-inventory></app-seller-inventory>
    }`,
  imports: [SellerInventoryComponent, VendorInventoryComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InventoryComponent {
  private accountSelection = inject(AccountSelectionService);

  readonly accountMarketplace = toSignal(this.accountSelection.singleAccountMarketplaceSelection$);

  readonly AccountType = AccountType;
}
